/**
 * userSelectors
 */
export const isSubscribed = (state) => state.auth.authUser.data.is_subscribed || false;